import { MotionValue,  useTransform } from "framer-motion";
import React, { useEffect } from "react";

import MapText from "./Maptext";
import Image from "next/image";
import MapLastText from "./MapLastText";
import MapText2 from "./Maptext2";

export function useParallax(value: MotionValue<number>, minDistance: number, maxDistance: number) {
    return useTransform(value, [0, 1], [minDistance, maxDistance]);
}
const Stars1 = ({certificate } : any ) => {

    const [result, setResult] = React.useState<any>(null);
    const [orderid , setOrderid] = React.useState<any>(null);
    const [load , setLoad] = React.useState(false);
   

    useEffect(() => {
    
        async function getdata() {
       
            
            const havadurumu = await fetch(`${process.env.NEXT_PUBLIC_URL}/api/siparis?certificate=${certificate}`);
            const order = await fetch(`${process.env.NEXT_PUBLIC_URL}/api/findorder?certificate=${certificate}`);
            const order2 = await order.json();

            const havadurumu2 = await havadurumu.json();
            setLoad(true)
            setOrderid(order2)
            setResult(havadurumu2)
        }
    
        getdata();
    
    }
    , [])
return (
    <>
    {load &&(
<section className="relative z-10 flex flex-col  w-screen !overflow-hidden h-[400vh] justify-center" id="home4" 
    ><section  className="relative z-10 flex  h-screen w-full justify-center" id="home5" 
    >


    <div className="mt-10 flex flex-col items-center justify-center sm:mt-0">
        <MapText2 />
        
    </div>
</section>
<section className="relative z-10 flex  h-screen w-full justify-center" id="maptext3" 
    >


    <div className="mt-10 flex flex-col items-center justify-center sm:mt-0">
        <MapText  />
        
    </div>
</section>

    <section className="relative z-10 flex  h-screen w-full justify-center" id="starmap" >

    <Image
    src={`https://imgs.mindbolt.net/certificate-map/SN-${orderid.orderid}-${orderid.urunid}.svg`}
    alt="Picture of the author"
    className="rounded-3xl w-full"
      width={500}
      height={500}
    />    </section>

<div className="mt-10 flex flex-col items-center justify-center sm:mt-0">
        <MapLastText parallax={1.2} title1={result.Tarih} title2={result.Konum} desc="İşte bu tarihte ve konumda, gökyüzüne baktığında yıldızlar tam olarak bu şekilde gözüküyordu!" />
        
    </div>
</section>
)}
</>
);
};

export default Stars1;